import React from 'react';
import PropTypes from 'prop-types';

/**
 * 開発者向けデバッグ情報表示コンポーネント
 * 環境変数またはフローティングボタンにより表示制御されます
 */
const DebugPanel = ({ 
  title = "🔧 デバッグ情報", 
  data = {}, 
  className = "mb-4 p-2 bg-gray-100 rounded text-xs",
  show = true,
  forceShow = null  // フローティングボタンからの制御用
}) => {
  // 環境変数による表示制御
  const isDevelopment = process.env.NODE_ENV === 'development';
  const showDebugFromEnv = process.env.REACT_APP_SHOW_DEBUG === 'true';
  
  // 表示条件の判定（優先順位: forceShow > 環境変数 > デフォルト）
  let shouldShow = false;
  
  if (isDevelopment) {
    if (forceShow !== null) {
      // フローティングボタンからの制御が最優先
      shouldShow = forceShow && show;
    } else {
      // 従来の環境変数による制御
      shouldShow = (showDebugFromEnv !== 'false') && show;
    }
  }
  
  if (!shouldShow) {
    return null;
  }
  
  return (
    <div className={className}>
      <div className="font-semibold text-gray-700 mb-1">{title}</div>
      {Object.entries(data).map(([key, value]) => (
        <div key={key}>
          <span className="font-medium">{key}:</span> {String(value)}
        </div>
      ))}
    </div>
  );
};

DebugPanel.propTypes = {
  title: PropTypes.string,
  data: PropTypes.object,
  className: PropTypes.string,
  show: PropTypes.bool,
  forceShow: PropTypes.bool,  // null, true, false を許可
};

export default DebugPanel; 